import type { UserStatusFilter } from '@UI/Pages/Administration/Users/Filters/UserFilterView';

/**
 * Narrows a server-provided enum value to `UserStatusFilter`. A value the front cannot translate into
 * `isActive`/`pendingInvitation` is discarded rather than displayed — showing an option nobody can
 * turn into a query would be a silently broken filter.
 */
export default function isUserStatusFilter(value: string): value is UserStatusFilter {
	return value === 'active' || value === 'invited' || value === 'deactivated';
}
